import { Box, Button, createStyles, makeStyles, Switch, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { InfoOutlined, LiveTvRounded } from '@material-ui/icons';
import { User } from 'myfitworld-model';
import React from 'react'
import { Controller, UnpackNestedValue, useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { updateUserDocument } from 'src/api/usersApi';
import messages from "../notifications/messages";
import globalMessages from "../../messages";
import {useMfwThemeProvider} from "myfitworld-utils";

interface HelpSectionValues extends User {
  infoButtons: boolean,
  tutorialButtons: boolean,
}
const useStyles = makeStyles(() =>
  createStyles({
    container: {
      marginTop: 20,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    containerButton: {
      marginTop: 20,
    }
  })
);

function InfoTutorialFormTable({user, onClose, setLoading, isLoading} : {
  user: User | null,
  onClose: () => void,
  setLoading: (loading: boolean) => void,
  isLoading: boolean,
}) {
  const {formatMessage} = useIntl();
  const classes = useStyles();
  const theme = useMfwThemeProvider();

  const showTutorialIcon = theme.theme.isWhiteLabel ? user?.helpSection?.tutorialButtons === true : user?.helpSection?.tutorialButtons !== false;

  const {control, handleSubmit, formState: {isDirty}} = useForm<HelpSectionValues>({
    criteriaMode: 'all',
    defaultValues: {
      ...user,
      infoButtons: user?.helpSection?.infoButtons !== false,
      tutorialButtons: showTutorialIcon,
    }
  });

  const onSubmitHandler = handleSubmit((helpSection: UnpackNestedValue<HelpSectionValues>) => {
  try {
    setLoading(true);
    const storeData = {...user, helpSection};

    updateUserDocument(storeData)
    .then(() => {
      setLoading(false);
      onClose();
    });
  } catch (error) {
    setLoading(false);
    console.error('Error Updating User', error);
  }
  });
  return (
    <form onSubmit={onSubmitHandler} className={classes.container}>
      <Table size="small">
        <TableHead>
          <TableRow>
          <TableCell></TableCell>
          <TableCell>{formatMessage(messages.help_center_type)}</TableCell>
          <TableCell>{formatMessage(messages.help_center_symbol)}</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          <TableRow>
            <TableCell>
              <Controller
                name='infoButtons'
                control={control}
                render={({onChange, value}) => {
                return (
                  <Switch
                  name='infoButtons'
                  color='primary'
                  checked={value}
                  onChange={(_, checked) => onChange(checked)}
                  />)
                }}
            />
            </TableCell>
            <TableCell>
              <Typography color="textPrimary">{formatMessage(messages.info_buttons)}</Typography>
            </TableCell>
            <TableCell align="center">
              <InfoOutlined />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <Controller
                name='tutorialButtons'
                control={control}
                render={({onChange, value}) => {
                return (
                  <Switch
                  name='tutorialButtons'
                  color='primary'
                  checked={value}
                  onChange={(_, checked) => onChange(checked)}
                  />)
                }}
              />
            </TableCell>
            <TableCell>
              <Typography color="textPrimary">{formatMessage(messages.info_tutorials)}</Typography>
            </TableCell>

            <TableCell align="center">
              <LiveTvRounded style={{ fontSize: 20, transform: 'rotate(180deg) scaleX(-1)', fill: "primary"}} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Box mt={2} className={classes.containerButton}>
        <Button color='primary' variant='contained' onClick={onSubmitHandler} disabled={isLoading || !isDirty}>
          {formatMessage(globalMessages.apply)}
        </Button>
      </Box>
    </form>
  )
}

export default InfoTutorialFormTable
